export const isExperienceAvailable = (
  experience: App.ExperienceOffer,
) => {
  return experience.status === 'ONLINE'
}
